import AppBar from "components/AppBar";
import PageLayout from "components/PageLayout";
import { Grid, Typography } from "@mui/material";

import { appVersion } from "utils/env";
import groupUpIcon from "assets/icons/logo.svg?url";
import styles from "./appInfo.module.scss";

export interface AppInfoProps {
  onBack?: () => void;
}

function AppInfo(props: AppInfoProps) {
  const { onBack } = props;

  return (
    <PageLayout appBar={<AppBar title='App info' onBack={onBack} />}>
      <Grid container direction='column' alignItems='center' className={styles.container}>
        <Grid item>
          <img src={groupUpIcon} alt='App icon' width={72} />
        </Grid>
        <Grid item>
          <Typography variant='body1'>GroupUp</Typography>
        </Grid>
        <Grid item>
          <Typography variant='caption' className={styles.version}>
            Version {appVersion}
          </Typography>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default AppInfo;
